/* RESPONSIBLE TEAM: team-inbox-experience */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type ConversationTableEntry from 'embercom/objects/inbox/conversation-table-entry';
import type InboxApi from 'embercom/services/inbox-api';
import type InboxState from 'embercom/services/inbox-state';
import type Session from 'embercom/services/session';

export default class extends Route {
  @service declare inboxApi: InboxApi;
  @service declare inboxState: InboxState;
  @service declare session: Session;

  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-inbox',
      react: this.reactEnabled(),
    };
  }

  reactEnabled() {
    return (
      this.session.isWorkspaceLoaded && this.session.workspace.canUseReactInboxConversationStream
    );
  }

  async model(params: { conversation_id: number }) {
    return await this.inboxApi.fetchConversation(params.conversation_id);
  }

  afterModel(conversation: ConversationTableEntry) {
    this.inboxState.activeConversation = conversation;
  }

  deactivate() {
    this.inboxState.activeConversation = undefined;
  }
}
